module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-700-319537c2e34754b8482dc10b5a5a678f.eot";